import { useTranslation } from 'react-i18next';

import { Breadcrumbs } from '@unified-checkout/design-system';

import { useSettingsUtils } from '../../Settings/useSettingsUtils';

import styles from './Header.module.scss';

const Header = () => {
  const { t } = useTranslation();
  const { internalPagesBreadcrumbs } = useSettingsUtils();

  return (
    <div className={styles['header']}>
      <Breadcrumbs linksProps={internalPagesBreadcrumbs.NOTIFICATIONS} />
      <div className={styles['header__content']}>
        <div className={styles['header__content-title']}>
          {t('innerLayout.notificationsPage.title')}
        </div>
        <div className={styles['header__content-subtitle']}>
          {t('innerLayout.notificationsPage.desc')}
        </div>
      </div>
    </div>
  );
};

export default Header;
